import React, { createContext, useContext, useEffect, useState } from "react";

const JoyrideContext = createContext();

export const JoyrideProvider = ({ children }) => {
	const [run, setRun] = useState(false);

	useEffect(() => {
		if (localStorage.joyride !== "1") {
			setRun(true);
			localStorage.joyride = "1";
		}
	}, []);

	const startJoyride = () => {
		setRun(true);
	};

	const stopJoyride = () => {
		setRun(false);
	};

	const value = {
		run,
		startJoyride,
		stopJoyride,
	};

	return (
		<JoyrideContext.Provider value={value}>{children}</JoyrideContext.Provider>
	);
};

export const useJoyride = () => useContext(JoyrideContext);
